let cartRef = null;
let docReady = false;
let setupRun = false;

function setupButtonClickHandlers() {
  $("button[data-checkout-btn]").click(function () {
    setTimeout(function () {
      var cookie = $.cookie("_ga_EENVJ92ML3");
      var session = cookie.split(".");

      var attributeName = "_ga_EENVJ92ML3";
      var attributeValue = session[2];

      var attributes = {};
      attributes[attributeName] = attributeValue;

      $.ajax({
        url: "/cart/update.js",
        type: "POST",
        data: {
          attributes: attributes,
        },
        success: function (result) {
          // window.location.href = window.location.href;
        },
        error: function (jqxhr, status, exception) {
          console.log(exception);
        },
      });
    }, 1000);
  });

  $("#addToCart").click(function () {
    setTimeout(function () {
      var cookie = $.cookie("_ga_EENVJ92ML3");
      var session = cookie.split(".");

      var attributeName = "_ga_EENVJ92ML3";
      var attributeValue = session[2];

      var attributes = {};
      attributes[attributeName] = attributeValue;

      $.ajax({
        url: "/cart/update.js",
        type: "POST",
        data: {
          attributes: attributes,
        },
        success: function (result) {
          // window.location.href = window.location.href;
        },
        error: function (jqxhr, status, exception) {
          console.log(exception);
        },
      });
    }, 1000);
  });
}

// Function to hide unavailable products
function hideUnavailableProducts() {
  $(".variants_grid__item.unavailable").each(function () {
    var variantId = $(this).find(".count").data("variant-id");
    var activeSubscription = $(
      ".rc_subscription_card_element_wrapper[data-variant-id='" + variantId + "'][data-status='ACTIVE']"
    );

    if (activeSubscription.length === 0) {
      $(this).hide();
    } else {
      $(this).show(); // Show the product if an active subscription exists
    }
  });
}

function initObserverToHideUnavailableProductsOnDocChange() {
  // Create a MutationObserver to detect changes in the DOM
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      // Check if new nodes have been added or attributes changed
      if (mutation.addedNodes.length || mutation.attributeName === "class") {
        hideUnavailableProducts();
      }
    });
  });

  // Start observing changes in the body and its descendants
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class"],
  });
}

function updateUpcartCheckoutButton() {
  const checkoutButtonLabel = "CHECKOUT";
  const checkoutButtonLoadingLabel = "Please wait...";
  // Add icon and uppercase text to checkout button
  $(".upcart-checkout-button")
    .html(
      `${checkoutButtonLabel} <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.42514 12C7.42574 10.7242 7.67208 9.49975 8.22756 8.34162C8.546 7.67794 8.9753 7.09327 9.54399 6.61238C9.56562 6.5941 9.59386 6.5829 9.61909 6.56845C9.61218 6.55607 9.60497 6.54369 9.59806 6.5313H0L0 5.47695H9.6239C7.96829 3.99597 7.49994 2.08747 7.40831 0C7.60299 0 7.77513 0 7.94727 0C8.1194 0 8.28524 0 8.45948 0C8.4751 0.262998 8.48081 0.51656 8.50634 0.768059C8.60668 1.74663 8.84792 2.68629 9.34601 3.5487C10.0478 4.76403 11.117 5.39764 12.5359 5.46693C12.6903 5.47459 12.8453 5.46958 13 5.47076V6.52953C12.9003 6.52953 12.8005 6.52717 12.7008 6.52894C11.1789 6.5543 10.0328 7.20383 9.30636 8.52472C8.71093 9.60737 8.4724 10.7773 8.4742 12H7.42514Z" fill="rgb(var(--color-button-text))"/>
    </svg>`
    )
    .on("click", function () {
      $(this).html(checkoutButtonLoadingLabel);
    });
}

function updateCartTitleAndIcon() {
  // Check if #cart-total exists, and if it does return early.
  if (document.querySelector("#header-cart-total")) {
    return;
  }
  const cartTitle = "Cart";
  // Add title and icon to cart header
  const cartTitleAndIconElem = document.createElement("p");
  cartTitleAndIconElem.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" class="cart-icon">
<g clip-path="url(#clip0_1352_148403)">
<path d="M8.3797 0.116455C7.52559 0.119842 6.70744 0.460636 6.10349 1.06458C5.49954 1.66853 5.15875 2.48669 5.15536 3.34079V3.98392H1.97144L1.93102 4.58799L1.2879 16.1959L1.24609 16.8836H15.5151L15.4747 16.1982L14.8316 4.59029L14.7916 3.98621H11.6045V3.34309C11.6017 2.48851 11.2611 1.66969 10.657 1.06524C10.0529 0.460781 9.23428 0.119725 8.3797 0.116455ZM8.3797 1.40637C8.89282 1.4065 9.3849 1.61039 9.74773 1.97322C10.1106 2.33606 10.3145 2.82813 10.3146 3.34125V3.98438H6.44528V3.34125C6.4454 2.82821 6.64923 2.33621 7.01196 1.97338C7.3747 1.61056 7.86665 1.40662 8.3797 1.40637ZM3.18097 5.27567H5.15628V7.21055H6.4462V5.27567H10.3155V7.21055H11.6054V5.27567H13.5807L14.1448 15.5941H2.6164L3.18097 5.27567Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_1352_148403">
<rect width="16.7671" height="16.7671" fill="white" transform="translate(0 0.116455)"/>
</clipPath>
</defs>
</svg>${cartTitle} (<span class="cart-total" id="header-cart-total">0</span>)`;
  document.querySelector(".upcart-header-close-button").insertAdjacentElement("afterbegin", cartTitleAndIconElem);
}

function updateCartSummaryWithShippingInfo() {
  // Add shipping text to cart summary
  const cartSummaryElem = document.querySelector(".cartSummarySection");
  const existingShippingTextElem = document.querySelector(".shipping-text");
  if (!cartSummaryElem || existingShippingTextElem) {
    return;
  }
  const shippingTextElem = document.createElement("p");
  const shippingCalculatedLabel = "Shipping calculated at checkout";
  shippingTextElem.innerHTML = shippingCalculatedLabel;
  shippingTextElem.classList.add("shipping-text");
  cartSummaryElem.insertAdjacentElement("beforeend", shippingTextElem);
}

function updateCartTotalTextToSubtotal() {
  // Replace 'Total' with 'Subtotal' in cart summary
  const cartSummaryTotalTitle = document.querySelector(".cartSubtotalTitle");
  if (!cartSummaryTotalTitle) {
    return;
  }
  function replaceTotalWithSubtotal(inputString) {
    const regex = /\bTotal\b/g;
    const subtotalLabel = "Subtotal";
    const result = inputString.replace(regex, `${subtotalLabel}`);
    return result;
  }
  cartSummaryTotalTitle.innerHTML = replaceTotalWithSubtotal(cartSummaryTotalTitle.innerHTML);
}

function hideToggleQuantityForSubscriptionAndRefills() {
  var desiredText = "_scent_title";
  $(".upcart-item-property")
    .filter(function () {
      return $(this).text().includes(desiredText);
    })
    .addClass("hide");
  $.getJSON("/cart.js", function (carts) {
    for (var i = 0; i < carts.items.length; i++) {
      if (carts.items[i].product_title == "Outer Case") {
        $(".upcart-products-section .upcart-product-item:eq(" + i + ")")
          .find(".styles_ProductRow__stepper__Cs6Bw")
          .remove();
      } else if (carts.items[i].product_title == "Refills") {
        $(".upcart-products-section .upcart-product-item:eq(" + i + ")")
          .find(".styles_ProductRow__stepper__Cs6Bw")
          .remove();
      }
    }
  });
}

let eventTriggered = false;
let rafId = null;

function handleCartChanges() {
  if (!eventTriggered) {
    hideToggleQuantityForSubscriptionAndRefills();
    // Set the flag to true to indicate that an event has been triggered
    eventTriggered = true;
    // Use requestAnimationFrame to reset the flag
    if (rafId === null) {
      rafId = window.requestAnimationFrame(() => {
        eventTriggered = false;
        rafId = null;
      });
    }
  }
}

// Why do we have a timeout?
function hideOnly() {
  setTimeout(function () {
    $(".upcart-item-property strong:contains(_Next_order_contains)").parent().hide();
    $(".upcart-item-property strong:contains(_Next order contains)").parent().hide();
    $(".upcart-item-property-subscribe").hide();
    hideToggleQuantityForSubscriptionAndRefills();
  }, 300);
}

function setupCartObserver() {
  const cartPopup = document.querySelector("#CartPopup .upcart-products-section");
  const cartCount = document.querySelector("#CartPopup .upcart-header-text");

  // Check if elements exist
  if (cartPopup && cartCount) {
    // Create a MutationObserver instance for cartPopup
    const cartPopupObserver = new MutationObserver(handleCartChanges);
    cartPopupObserver.observe(cartPopup, { childList: true, subtree: true });

    // Create a MutationObserver instance for cartCount
    const cartCountObserver = new MutationObserver(hideOnly);
    cartCountObserver.observe(cartCount, { childList: true, subtree: true });
  } else {
    // console.error("Elements not found in the DOM");
  }
}

function hideAdditionalItemProperties() {
  const scentTitleText = "_scent_title";
  const imagePropertyText = "image:";
  $(".upcart-item-property")
    .filter(function () {
      return $(this).text().includes(scentTitleText);
    })
    .addClass("hide");
  $(".upcart-item-property")
    .filter(function () {
      return $(this).text().includes(imagePropertyText);
    })
    .addClass("hide");
}

function setupHideOnPopupChangeObserver() {
  const targetElement = document.querySelector("#CartPopup .upcart-header-text");
  const observer = new MutationObserver((mutationsList, observer) => {
    hideOnly();
  });

  const config = { subtree: true, characterData: true };
  observer.observe(targetElement, config);
}

function hideRemovedItem(removedItem) {
  if (jQuery(`body`).hasClass("template-cart")) {
    if (jQuery(`#CartPageForm .cart__item[data-key="${removedItem.key}"]`)) {
      jQuery(`#CartPageForm .cart__item[data-key="${removedItem.key}"]`).hide();
    }
  }
}

function resetUpcartOnCartUpdatedListener() {
  window.upcartOnCartUpdated = (cartToShow) => {
    onCartInitAndUpdate();
  };
}

function handleNextOnCartUpdatedForBundleItem(removedItem) {
  window.upcartOnCartUpdated = (cartToShow) => {
    let formData = {
      updates: {},
    };
    let total_price = 0;

    cartToShow.items.filter((item) => {
      if (item.properties._unique_box_id === removedItem.properties._unique_box_id) {
        formData.updates[item.key] = 0;
      }
      if (item.properties._unique_box_id != removedItem.properties._unique_box_id) {
        if (item.original_price != item.final_price) {
          total_price += item.final_price * item.quantity;
        } else {
          total_price += item.original_price * item.quantity;
        }
      }
    });

    if (formData.updates) {
      try {
        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            if (response.ok) {
              var cart_count = cartToShow.items.length;
              var final_price = Shopify.formatMoney(total_price, window.moneyFormat);
              Object.keys(formData.updates).filter((key) => {
                if (jQuery(`.upcart-product-item[id="${key}"]`)) {
                  jQuery(`.upcart-product-item[id="${key}"]`).hide();
                  if (jQuery(`body`).hasClass("template-cart")) {
                    if (jQuery(`#CartPageForm .cart__item[data-key="${key}"]`)) {
                      jQuery(`#CartPageForm .cart__item[data-key="${key}"]`).hide();
                    }
                  }
                }
                if (cart_count > 0) {
                  cart_count -= 1;
                }
              });

              if (cart_count == 0) {
                if (jQuery(`body`).hasClass("template-cart")) {
                  location.reload(true);
                } else {
                  jQuery(`.cart-count-bubble`).html(`${cart_count}`);
                  cartRef.item_count = 0;
                  onCartInitAndUpdate();
                }
              } else {
                if (jQuery(`body`).hasClass("template-cart")) {
                  jQuery(`#CartPageForm .cart__item-sub [data-subtotal]`).html(`${final_price}`);
                }
                jQuery(`.cart-count-bubble`).html(cart_count);
              }

              return response.json();
            }
            throw new Error("Something went wrong");
          })
          .catch((error) => {
            console.log("Error:", error);
          });
      } catch (e) {
        console.log(e);
      }
    }
    resetUpcartOnCartUpdatedListener();
  };
}

function handleNextOnCartUpdatedForNonBundleItem(removedItem) {
  window.upcartOnCartUpdated = (cartToShow) => {
    let total_price = 0;
    var cart_count = cartToShow.items.length;

    cartToShow.items.filter((item) => {
      if (item.original_price != item.final_price) {
        total_price += item.final_price * item.quantity;
      } else {
        total_price += item.original_price * item.quantity;
      }
    });

    var final_price = Shopify.formatMoney(total_price, window.moneyFormat);

    jQuery(`#CartPageForm .cart__item-sub [data-subtotal]`).html(`${final_price}`);

    resetUpcartOnCartUpdatedListener();
  };
}

function setHeaderCartItemsCount() {
  jQuery(".cart-total").text(cartRef.item_count);
}

function updateCartSubTotalValue() {
  const formattedPrice = Shopify.formatMoney(cartRef.total_price, window.moneyFormat).replace(/"/g, "");
  jQuery(".cartSubtotalValue").text(formattedPrice);
}

function updateCartWithItemsHeaderText() {
  jQuery(".upcart-header-text")
    .attr("id", "header-text")
    .text("🌹️ YOUR CART IS SMELLING GOOOOOD 🌹")
    .removeClass("empty-cart-header-text")
    .addClass("full-cart-header-text");
}

function updateEmptyCartState() {
  const emptyCartText = "YOUR CART IS SCENTLESS.<br>LET’S FIX THAT.";
  jQuery(".styles_CartPreview__empty__WFP86 h3").html(emptyCartText);
  jQuery(".upcart-header-text")
    .attr("id", "header-text")
    .text("⚠️️ YOUR CART COULD SMELL BETTER ⚠️")
    .addClass("empty-cart-header-text");

  //if continue shopping button already exists, do not add it again
  if (document.querySelector(".continue-shopping-button")) {
    return;
  }

  const newImageElement = document.createElement("img");
  newImageElement.src = '//www.getfussy.com/cdn/shop/t/228/assets/empty-cart.gif?v=157837417115028426781728038323';
  newImageElement.classList.add("empty-cart-image");

  const newButtonElement = document.createElement("button");
  const continueShoppingText = "CONTINUE SHOPPING";
  newButtonElement.innerHTML = `${continueShoppingText} <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow-icon">
    <path d="M7.42514 12C7.42574 10.7242 7.67208 9.49975 8.22756 8.34162C8.546 7.67794 8.9753 7.09327 9.54399 6.61238C9.56562 6.5941 9.59386 6.5829 9.61909 6.56845C9.61218 6.55607 9.60497 6.54369 9.59806 6.5313H0L0 5.47695H9.6239C7.96829 3.99597 7.49994 2.08747 7.40831 0C7.60299 0 7.77513 0 7.94727 0C8.1194 0 8.28524 0 8.45948 0C8.4751 0.262998 8.48081 0.51656 8.50634 0.768059C8.60668 1.74663 8.84792 2.68629 9.34601 3.5487C10.0478 4.76403 11.117 5.39764 12.5359 5.46693C12.6903 5.47459 12.8453 5.46958 13 5.47076V6.52953C12.9003 6.52953 12.8005 6.52717 12.7008 6.52894C11.1789 6.5543 10.0328 7.20383 9.30636 8.52472C8.71093 9.60737 8.4724 10.7773 8.4742 12H7.42514Z" fill="rgb(var(--color-button-text))"/>
  </svg>`;
  newButtonElement.classList.add("continue-shopping-button");
  document.querySelector(".styles_CartPreview__empty__WFP86").classList.add("empty-cart-container");
  document.querySelector(".styles_CartPreview__empty__WFP86").insertAdjacentElement("beforeend", newButtonElement);
  document.querySelector(".styles_CartPreview__empty__WFP86").insertAdjacentElement("afterbegin", newImageElement);
  document.querySelector(".continue-shopping-button").addEventListener("click", window.upcartCloseCart);
}

function createAndUpdateQuantityInfoIcon(item) {
  if (document.querySelector(`.quantity-${item.id}`)) {
    const quantityInfoIcon = document.querySelector(`.quantity-${item.id}`);
    quantityInfoIcon.innerText = item.quantity;
    return;
  }
  const quantityInfoIcon = document.createElement("div");
  quantityInfoIcon.classList.add(`quantity-info-icon`);
  quantityInfoIcon.classList.add(`quantity-${item.id}`);
  quantityInfoIcon.innerText = item.quantity;
  document.getElementById(item.key).insertAdjacentElement("afterbegin", quantityInfoIcon);
}

function addDeliveryTitleToSellingPlanName() {
  const sellingPlanNameElems = document.querySelectorAll(".upcart-item-property-subscription");
  const deliveryTitle = "Delivery every";
  sellingPlanNameElems.forEach((elem) => {
    if (!elem.innerText.includes(deliveryTitle)) {
    elem.innerText = `${deliveryTitle} ${elem.innerText}`;
    }
  });
};

function onCartInitAndUpdate() {
  updateCartSubTotalValue();


  setTimeout(function () {
    updateCartTitleAndIcon();
    updateUpcartCheckoutButton();
    updateCartSummaryWithShippingInfo();
    if (cartRef.item_count === 0) {
      updateEmptyCartState();
    } else {
      updateCartWithItemsHeaderText();
      addDeliveryTitleToSellingPlanName();
    }
  });

  setTimeout(function () {
    if (cartRef.item_count > 0) {
      cartRef.items.forEach((item) => {
        createAndUpdateQuantityInfoIcon(item);
      });
    }
  }, 100);

  setTimeout(function () {
    setHeaderCartItemsCount();
    updateCartTotalTextToSubtotal();
  }, 300);
}

function setupHandlerToHideQuantity0Items() {
  window.upcartModifyCart = (cart) => {
    cart.items = cart.items.filter((item) => item.quantity > 0);

    cartRef = cart;
    onCartInitAndUpdate();

    return cart;
  };
}

// This function has been imported from the custom html in the upcart settings but it is not being used.
function registerTrashButtons() {
  var trashButtons = document.querySelectorAll('div[class^="styles_TrashButton__deleteButton__"]');
  trashButtons.forEach((button) => {
    button.addEventListener("click", () => {
      setTimeout(() => {
        window.upcartRegisterAddToCart();
        console.log("Item deleted!");
      }, 1000);
    });
  });
}

function runSetup() {
  if (setupRun) {
    return;
  }

  if (!cartRef || !docReady) {
    return;
  }

  setupRun = true;

  resetUpcartOnCartUpdatedListener();
  setupButtonClickHandlers();

  // 1
  hideUnavailableProducts();
  initObserverToHideUnavailableProductsOnDocChange();

  // 2
  setupCartObserver();

  setTimeout(function () {
    hideAdditionalItemProperties();
  }, 300);

  hideToggleQuantityForSubscriptionAndRefills();

  setTimeout(function () {
    setupHideOnPopupChangeObserver();
    hideOnly();
  }, 2500);

  setupHandlerToHideQuantity0Items();

  onCartInitAndUpdate();

  window.upcartOnItemRemoved = async (_, removedItem) => {
    hideRemovedItem(removedItem);

    if (removedItem.properties._unique_box_id) {
      handleNextOnCartUpdatedForBundleItem(removedItem);
    } else {
      handleNextOnCartUpdatedForNonBundleItem(removedItem);
    }
  };
}

// Wait for upcart and doc ready before running setup.
jQuery(document).ready(function () {
  // This is incase we've missed the cart loaded event, we retrigger it.
  if (window.upcartRefreshCart && !cartRef) {
    window.upcartRefreshCart();
  }

  docReady = true;
  runSetup();
});

window.upcartOnCartLoaded = (cart) => {
  // add a unique class to signal to control whether some parts of the custom code from the upcart app editor runs
  jQuery("#upCart").addClass("nb-fussy-upcart-test");
  cartRef = cart;
  runSetup();
};
